import * as yup from 'yup'
import { unitRoleOptions } from './helpers'

export const householdPreApprovedCreateSchema = yup
  .object({
    userEmail: yup.string().email().required(),
    unitRole: yup.string().oneOf(unitRoleOptions).required(),
  })
  .required()
